import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  exports: [TranslocoModule],
})

export class TranslateModule {}
